import api from './api';

export interface TipoProjetoFase {
  id: string;
  nome: string;
  codigo: number;
}

export const getAllTiposProjetoFase = () => api.get<TipoProjetoFase[]>(`tiposprojetofase/`);
export const getTipoProjetoFaseById = (id: string) => api.get<TipoProjetoFase>(`tiposprojetofase/${id}`);
